import React from 'react';
import {array, func} from 'prop-types';
import {connect} from 'react-redux';
import {createFragmentContainer, graphql} from 'react-relay';
import {loadLocalCart, consolidateCart} from '../../../actions/cartActions';
import MobileNavCart from './MobileNavCart';
import get from 'lodash.get';
import AddCartItemMutation from '../../../mutations/AddCartItemMutation';

class MobileNavCartContainer extends React.Component {

    componentDidMount() {
        this.props.dispatch(loadLocalCart());
    }

    componentWillReceiveProps(nextProps) {
        const {cartItems, dispatch, relay, user} = nextProps;
        if (user && cartItems.length) {
            AddCartItemMutation.commit(
                relay.environment,
                {
                    itemIds: cartItems.map(c => c.id),
                    onCompleted: (res, errors) => {
                        if (errors) {
                            return;
                        }
                        dispatch(consolidateCart({res, cartItems}));
                    },
                    onError: error => {
                        console.error(error);
                    }
                }
            );
        }
    }

    render() {
        const {serviceCart, cartItems, onClick} = this.props;
        const cartItemCount = cartItems.length || serviceCart.length;
        return <MobileNavCart onClick={onClick} cartItemCount={cartItemCount} />;
    }
}

MobileNavCartContainer.propTypes = {
    serviceCart: array.isRequired,
    cartItems: array.isRequired,
    onClick: func.isRequired,
    dispatch: func.isRequired
};

MobileNavCartContainer = connect((state, props) => {
    const cartItems = get(state, 'cart.items', []);
    const serviceCart = get(props, 'user.cart.items') || [];

    return {
        cartItems,
        serviceCart
    };
})(MobileNavCartContainer);

export default createFragmentContainer(
    MobileNavCartContainer,
    graphql`
        fragment MobileNavCartContainer_user on User {
            cart {
                items {
                    item {
                        itemId
                    }
                }
            }
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavIcons/MobileNavCartContainer.jsx